// Sessions' titles (their most recent prompt's summary) for the lists and
// cards that name sessions by more than their ids: the workspace's sidebar and
// add panel, and the board's machine cards. Read once per session and kept.
import { useEffect, useState } from "react";
import { getSessionLabels } from "./sessionLabels.js";
import { rangeToTimeRange } from "./analyticsClient.js";

const DAY = 86_400_000;

let labeler = getSessionLabels;
// A stand-in for the labels read, for harnesses and tests.
export function __setSessionTitleLabeler(fn) { labeler = fn || getSessionLabels; }

// The titles of `ids` (id -> title, null where a session has none), read
// within a day either side of `span` ({ from, to } in ms), else the last 30
// days.
export function useSessionTitles(ids, span) {
  const [titles, setTitles] = useState(() => new Map());
  const want = ids.filter((id) => !titles.has(id));
  const key = want.join(",");
  useEffect(() => {
    if (!want.length) return undefined;
    let dead = false;
    const from = Number.isFinite(span?.from) ? span.from - DAY : Date.now() - 30 * DAY;
    const to = Number.isFinite(span?.to) ? span.to + DAY : Date.now();
    Promise.resolve(labeler(want, rangeToTimeRange({ from: new Date(from).toISOString(), to: new Date(to).toISOString() }))).then(
      (m) => { if (!dead) setTitles((cur) => { const next = new Map(cur); for (const id of want) next.set(id, m?.get?.(id) || null); return next; }); },
      () => { if (!dead) setTitles((cur) => { const next = new Map(cur); for (const id of want) next.set(id, null); return next; }); },
    );
    return () => { dead = true; };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return titles;
}
